var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"size":_vm.size,"loading":_vm.saving,"disabled":!_vm.ready || _vm.saving},on:{"click":_vm.approveRequest}},[_vm._v("Approve")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }